module.exports = __webpack_public_path__ + "static/media/ttaanga.d47181c4.png";